import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import './MenuPage.css';

const MenuPage = () => {
  return (
    <div className="menu-page">
      <Header />
      <Menu />
      <Footer />
    </div>
  );
};

export default MenuPage;
